// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-green {
  background: var(
    --Yalda-BG,
    #2C719D
  );
}
`, "",{"version":3,"sources":["webpack://./src/Modals/ModalLayout/ModalGeneral.css"],"names":[],"mappings":"AAAA;EACE;;;GAGC;AACH","sourcesContent":[".bg-green {\n  background: var(\n    --Yalda-BG,\n    #2C719D\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
